<ng-container>
    <div class="mx-5 my-4 company-details-container">
        <form [formGroup]="companyDetailForm">
            <div class="px-2">
                <div class="row mb-5 mt-6">
                  <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': companyDetailForm.get('companyName')?.invalid && companyDetailForm.get('companyName')?.touched}">Corporate Legal Name</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [ngClass]="{'border-danger': companyDetailForm.get('companyName')?.invalid && companyDetailForm.get('companyName')?.touched}"
                            formControlName="companyName" placeholder="" name="companyName" maxlength="128" autocomplete="off"/>
                        @if (companyDetailForm.get('companyName')?.invalid && companyDetailForm.get('companyName')?.touched) {
                            <span class="text-danger">
                                @if (companyDetailForm.get('companyName')?.errors?.['required']) {
                                    Corporate Legal Name is required.
                                }
                                @else if (companyDetailForm.get('companyName')?.errors?.['maxlength']) {
                                    Corporate Legal Name must be no longer than 128 characters.
                                }
                            </span>
                        }
                    </div>
                  <div class="col-12 col-md-6 form-container">
                    <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': companyDetailForm.get('corporateMail')?.invalid && companyDetailForm.get('corporateMail')?.touched}">Corporate Email</label>
                    <input type="email" class="form-control form-control-lg form-control-solid" [ngClass]="{'border-danger': companyDetailForm.get('corporateMail')?.invalid && companyDetailForm.get('corporateMail')?.touched}"
                        formControlName="corporateMail"  placeholder="" name="corporateMail" autocomplete="off"/>
                    @if (companyDetailForm.get('corporateMail')?.invalid && companyDetailForm.get('corporateMail')?.touched) {
                        <span class="text-danger">
                            @if (companyDetailForm.get('corporateMail')?.errors?.['required']) {
                                Corporate Email is required.
                            }
                            @else if (companyDetailForm.get('corporateMail')?.errors?.['pattern']) {
                                Please enter a valid email address.
                            }
                        </span>
                    }
                </div>
                </div>
                <div class="row mb-5">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': companyDetailForm.get('companyType')?.invalid && companyDetailForm.get('companyType')?.touched}">Company Type</label>
                        <select class="form-control form-control-lg form-control-solid" [ngClass]="{'border-danger': companyDetailForm.get('companyType')?.invalid && companyDetailForm.get('companyType')?.touched}"
                            formControlName="companyType"  name="companyType" >
                            <option [value]="null">Select Company Type</option>
                            <option [value]="type.value" *ngFor="let type of companyTypeList()">
                                {{ type.label }}
                            </option>
                        </select>
                        @if (companyDetailForm.get('companyType')?.invalid && companyDetailForm.get('companyType')?.touched) {
                            <span class="text-danger">
                                @if (companyDetailForm.get('companyType')?.errors?.['required']) {
                                    Company Type is required.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <input type="checkbox" class="form-check-input me-2" formControlName="isActive" name="isActive" [value]="1"
                            [checked]="companyDetailForm.get('isActive')?.value === 1" /> 
                        <label class="form-check-label mt-1 ms-1 text-black">Active</label>
                    </div>
                </div>
                <div class="row mb-5">
                    <h4 class="fw-bold text-gray-900 mb-8">Corporate Head Office Address</h4>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3">Unit/Suite Number</label>
                        <input type="text" (keypress)="allowStreetNumberCharacters($event)" class="form-control form-control-lg form-control-solid"
                            formControlName="unitNum" placeholder="" name="unitNum"/>
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': companyDetailForm.get('streetNum')?.invalid && companyDetailForm.get('streetNum')?.touched}">Street #</label>
                        <input type="text" (keypress)="allowStreetNumberCharacters($event)" class="form-control form-control-lg form-control-solid" [ngClass]="{'border-danger': companyDetailForm.get('streetNum')?.invalid && companyDetailForm.get('streetNum')?.touched}"
                            formControlName="streetNum" placeholder="" name="streetNum"/>
                        @if (companyDetailForm.get('streetNum')?.invalid && companyDetailForm.get('streetNum')?.touched) {
                            <span class="text-danger">
                                @if (companyDetailForm.get('streetNum')?.errors?.['required']) {
                                    Street num is required.
                                }
                            </span>   
                        }
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': companyDetailForm.get('streetName')?.invalid && companyDetailForm.get('streetName')?.touched}">Street name</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [ngClass]="{'border-danger': companyDetailForm.get('streetName')?.invalid && companyDetailForm.get('streetName')?.touched}"  
                        formControlName="streetName" placeholder="" name="streetName" maxlength="128" />
                        @if (companyDetailForm.get('streetName')?.invalid && companyDetailForm.get('streetName')?.touched) {
                            <span class="text-danger">
                                @if (companyDetailForm.get('streetName')?.errors?.['required']) {
                                    Street name is required.
                                }@else if (companyDetailForm.get('streetName')?.errors?.['pattern']) {
                                    Street name must be alphanumeric.
                                }@else if(companyDetailForm.get('streetName')?.errors?.['maxlength']){
                                    Street name must be no longer than 128 characters.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" (change)="onCountryChange($event)" [ngClass]="{'border-danger': companyDetailForm.get('countryId')?.invalid && companyDetailForm.get('countryId')?.touched}">Country</label>
                        <select class="form-control form-control-lg form-control-solid" (change)="onCountryChange($event)"
                            [ngClass]="{'border-danger': companyDetailForm.get('countryId')?.invalid && companyDetailForm.get('countryId')?.touched}"
                            formControlName="countryId" name="countryId" maxlength="64">
                            <option [value]="null">Select Country</option>
                            <option [value]="country.countryId" *ngFor="let country of countryList()">
                                {{country.countryName}}
                            </option>
                        </select>
                        @if (companyDetailForm.get('countryId')?.invalid && companyDetailForm.get('countryId')?.touched) {
                            <span class="text-danger">
                                @if (companyDetailForm.get('countryId')?.errors?.['required']) {
                                    Country is required.
                                }@else if(companyDetailForm.get('countryId')?.errors?.['maxlength']){
                                    Country must be no longer than 64 characters.
                                }
                            </span>
                        }
                    </div>
                </div>
                <div class="row mb-5">
                     <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': companyDetailForm.get('zipCode')?.invalid && companyDetailForm.get('zipCode')?.touched}">Zip code</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" 
                            [ngClass]="{'border-danger': companyDetailForm.get('zipCode')?.invalid && companyDetailForm.get('zipCode')?.touched}"
                            formControlName="zipCode" (blur)="onZipCodeBlur()" placeholder="" name="zipCode"/>
                        @if (companyDetailForm.get('zipCode')?.invalid && companyDetailForm.get('zipCode')?.touched) {
                            <span class="text-danger">
                                @if (companyDetailForm.get('zipCode')?.errors?.['required']) {
                                    Zip code is required.
                                }@else if (companyDetailForm.get('zipCode')?.errors?.['pattern']) {
                                    Invalid Zip Code.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': companyDetailForm.get('stateId')?.invalid && companyDetailForm.get('stateId')?.touched}">State</label>
                        <mat-select [title]="getStateName(companyDetailForm.get('stateId')?.value) || ''" class="form-control form-control-lg form-control-solid" formControlName="stateId" name="stateId" (openedChange)="onStateDropdownOpened($event)" (selectionChange)="onStateChange()">
                            <mat-select-trigger>
                                {{getStateName(companyDetailForm.get('stateId')?.value) || ''}}
                            </mat-select-trigger>
                            <!-- Search input -->
                            <div class="search-container mb-2 mx-2">
                                <input
                                    placeholder="Search..."
                                    [value]="searchState() ? searchState() : ''"
                                    (input)="onStateSearch($event)"
                                    (keydown.space)="$event.stopPropagation()" 
                                    class="form-control form-control-lg form-control-solid"
                                />
                            </div>
                            <div class="option-container pt-4">
                                <!-- Options -->
                                <mat-option *ngFor="let state of filteredStatesList() || []" [value]="state.stateId">
                                    {{ state.stateName }}
                                </mat-option>
                                <!-- No results -->
                                <mat-option *ngIf="filteredStatesList().length === 0" disabled>
                                    No options found
                                </mat-option>
                            </div>
                        </mat-select>
                        @if (companyDetailForm.get('stateId')?.invalid && companyDetailForm.get('stateId')?.touched) {
                            <span class="text-danger">
                                @if (companyDetailForm.get('stateId')?.errors?.['required']) {
                                    State is required.
                                }@else if(companyDetailForm.get('stateId')?.errors?.['maxlength']){
                                    State must be no longer than 64 characters.
                                }
                            </span>
                        }
                    </div>
                    
                </div>
                <div class="row mb-5">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': companyDetailForm.get('cityId')?.invalid && companyDetailForm.get('cityId')?.touched}">City</label>
                        <mat-select [title]="getCityName(companyDetailForm.get('cityId')?.value) || ''" class="form-control form-control-lg form-control-solid" formControlName="cityId" name="cityId" (openedChange)="onCityDropdownOpened($event)">
                            <mat-select-trigger>
                                {{ getCityName(companyDetailForm.get('cityId')?.value) }}
                            </mat-select-trigger>
                            <!-- Search input -->
                            <div class="search-container mb-2 mx-2">
                                <input
                                    placeholder="Search..."
                                    [value]="searchCity() ? searchCity() : ''"
                                    (input)="onCitySearch($event)"
                                    (keydown.space)="$event.stopPropagation()" 
                                    class="form-control form-control-lg form-control-solid"
                                />
                            </div>
                            <div class="option-container pt-4">
                                <!-- Options -->
                                <mat-option *ngFor="let city of filteredCityList() || []" [value]="city.cityId">
                                    {{ city.cityName }}
                                </mat-option>
                                <!-- No results -->
                                <mat-option *ngIf="filteredCityList().length === 0" disabled>
                                    No options found
                                </mat-option>
                            </div>
                        </mat-select>
                        @if (companyDetailForm.get('cityId')?.invalid && companyDetailForm.get('cityId')?.touched) {
                            <span class="text-danger">
                                @if (companyDetailForm.get('cityId')?.errors?.['required']) {
                                    City is required.
                                }@else if(companyDetailForm.get('cityId')?.errors?.['maxlength']){
                                    City must be no longer than 64 characters.
                                }
                            </span>
                        }
                    </div>
                   <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': companyDetailForm.get('countyId')?.invalid && companyDetailForm.get('countyId')?.touched}">County</label>
                        <mat-select [title]="getCountyName(companyDetailForm.get('countyId')?.value) || ''" class="form-control form-control-lg form-control-solid" formControlName="countyId" name="countyId" (openedChange)="onCountyDropdownOpened($event)">
                            <mat-select-trigger>
                                {{ getCountyName(companyDetailForm.get('countyId')?.value) }}
                            </mat-select-trigger>
                            <!-- Search input -->
                            <div class="search-container mb-2 mx-2">
                                <input
                                    placeholder="Search..."
                                    [value]="searchCounty() ? searchCounty() : ''"
                                    (input)="onCountySearch($event)"
                                    (keydown.space)="$event.stopPropagation()" 
                                    class="form-control form-control-lg form-control-solid"
                                />
                            </div>
                            <div class="option-container pt-4">
                                <!-- Options -->
                                <mat-option *ngFor="let county of filteredCountyList() || []" [value]="county.countyId">
                                    {{ county.countyName }}
                                </mat-option>
                                <!-- No results -->
                                <mat-option *ngIf="filteredCountyList().length === 0" disabled>
                                    No options found
                                </mat-option>
                            </div>
                        </mat-select>
                        @if (companyDetailForm.get('countyId')?.invalid && companyDetailForm.get('countyId')?.touched) {
                            <span class="text-danger">
                                @if (companyDetailForm.get('countyId')?.errors?.['required']) {
                                    County is required.
                                }@else if(companyDetailForm.get('countyId')?.errors?.['maxlength']){
                                    County must be no longer than 64 characters.
                                }
                            </span>
                        }
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': companyDetailForm.get('corporatePhone')?.invalid && companyDetailForm.get('corporatePhone')?.touched}">Phone Number</label>
                        <ngx-intl-tel-input
                            [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
                            [enableAutoCountrySelect]="false"
                            [enablePlaceholder]="false"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                            [searchCountryPlaceholder]="'Search...'"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="companyDetailForm.get('corporatePhoneCountryCode')?.value || CountryISO.UnitedStates"
                            [maxLength]="getMaxPhoneLength(companyDetailForm.get('corporatePhoneCountryCode')?.value)"
                            [phoneValidation]="false"
                            [separateDialCode]="true"
                            formControlName="corporatePhone"
                            name="corporatePhone"
                            (countryChange)="onCorporatePhoneCountryChange($event)">
                        </ngx-intl-tel-input>
                        @if (companyDetailForm.get('corporatePhone')?.invalid && companyDetailForm.get('corporatePhone')?.touched) {
                            <span class="text-danger">
                                @if (companyDetailForm.get('corporatePhone')?.errors?.['required']) {
                                    Phone Number is required.
                                }@else if (companyDetailForm.get('corporatePhone')?.errors?.['pattern'] || companyDetailForm.get('corporatePhone')?.errors?.['validatePhoneNumber']) {
                                    Please enter a valid Phone Number.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': companyDetailForm.get('websiteURL')?.invalid && companyDetailForm.get('websiteURL')?.touched}">Website URL</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" 
                            [ngClass]="{'border-danger': companyDetailForm.get('websiteURL')?.invalid && companyDetailForm.get('websiteURL')?.touched}"
                            formControlName="websiteURL" placeholder="" name="websiteURL"/>
                        @if (companyDetailForm.get('websiteURL')?.invalid && companyDetailForm.get('websiteURL')?.touched) {
                            <span class="text-danger">
                                @if (companyDetailForm.get('websiteURL')?.errors?.['required']) {
                                    Website URL is required.
                                }@else if (companyDetailForm.get('websiteURL')?.errors?.['pattern']) {
                                    Please enter a valid Website URL.
                                }
                            </span>
                        }
                    </div>
                </div>                                                 
          </div>
        </form>
    </div>
</ng-container>
<!-- @if(this.isLoading()){
    <app-spinner></app-spinner>
} -->